// LGEIN-239 Start
function ggStartApp() {
	gapi.load('auth2', function(){
		// Retrieve the singleton for the GoogleAuth library and set up the client.
		auth2 = gapi.auth2.init({
			client_id: ggOptions.appId+'.apps.googleusercontent.com',
			scope: 'profile'
		});
	});
};
// LGEIN-239 End

$(document).ready(function(){
	if(!!document.querySelector('.common-sign-in-area') || !!document.querySelector('.signup-wrap')){
		if ( document.domain !== 'localhost' ){
			// CORS
			document.domain = 'lg.com';
		}
	} else {
		return false;
	}
	/* LGEUK-75 : 20200717 add */
	var countryCode = $('html').data('countrycode').toUpperCase();
	var cookieA = false;
	
	if(typeof ePrivacyCookies!='undefined' && ePrivacyCookies.get('LGCOM_ADVERTISING')){ // LGEITF-182
		cookieA = true;
	}
	console.log('treasuredata cookie flag : '+cookieA);
	if(cookieA){
		$('head').append('<!-- Treasure Data --><script type="text/javascript">!function(t,e){if(void 0===e[t]){e[t]=function(){e[t].clients.push(this),this._init=[Array.prototype.slice.call(arguments)]},e[t].clients=[];for(var r=function(t){return function(){return this["_"+t]=this["_"+t]||[],this["_"+t].push(Array.prototype.slice.call(arguments)),this}},s=["blockEvents","unblockEvents","setSignedMode","setAnonymousMode","resetUUID","addRecord","fetchGlobalID","set","trackEvent","trackPageview","trackClicks","ready"],n=0;n<s.length;n++){var c=s[n];e[t].prototype[c]=r(c)}var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=("https:"===document.location.protocol?"https:":"http:")+"//cdn.treasuredata.com/sdk/2.2/td.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)}}("Treasure",this);</script>');
	}	
	/*// LGEUK-75 : 20200717 add */
	
	var btnFacebook = $(".btn-fb");
	btnFacebook.click(function(e){
		/**
		 * SNS 로그인전 API 접속해서 SNS로그인된 상태인지 확인후 팝업 열기
		 * 
		 */
		// LGEUK-75 Start 
		if(cookieA || treasureDataFlag != 'Y'){ // LGEITF-182
			FB.login(function(response) {
				FBstatusChangeCallback(response);
			}, {scope: 'public_profile,email'});
		}else{
			ePrivacyCookies.view('click');
		}	
		// LGEUK-75 End		
	});
	
	// LGEUK-75 Start 
	var btnTwitter = $(".btn-tw");
	btnTwitter.click(function(e){
		if(cookieA || treasureDataFlag != 'Y'){
			twitterLoginPopup();
		}else{
			ePrivacyCookies.view('click');
		}		
	});
	// LGEUK-75 End 
	
	// LGEIN-239 Start
	var btnGoogle = $(".btn-gg");
	btnGoogle.click(function(e){
		
		// 쿠키값이 N이거나 특정 지정 국가면 로그인 안됨.
		if(cookieA || treasureDataFlag != 'Y'){
			var gauth = gapi.auth2.getAuthInstance();
			
			// 구글로그인 성공
			gauth.signIn().then(function(response){
				console.log('Logined');
				var profile = gauth.currentUser.get().getBasicProfile();
				
//			  console.log('email : ' + profile.getEmail());
//			  console.log('name : ' + profile.getName());
//			  console.log('id : ' + profile.getId());
//			  console.log('givenName : ' + profile.getGivenName());
//			  console.log('familyName : ' + profile.getFamilyName());
//			  console.log('imageUrl : ' + profile.getImageUrl());
				
				var emailAddr = profile.getEmail() || "";
				var snsId =  profile.getId() || "";
				var snsName =  profile.getName() || "";
				var snsType = "GOOGLE";
				var snsFlag = "Y";
				
				var registredUrl = btnGoogle.data().url;

				loginAPI({
					emailAddr : emailAddr,
					snsId : snsId,
					snsName : snsName,
					snsType : snsType,
					snsFlag : snsFlag,
					registredUrl : registredUrl,
					windowUrl : ggOptions.windowUrl
				});
			});
		}else{
			ePrivacyCookies.view('click');
		}
	});
	// LGEIN-239 End

	var btnWeibo = $(".btn-wb");
	if (btnWeibo.length){		
		btnWeibo.click(function(e){
			WB2.login(function(){
				console.log('weibo Login!!!' , arguments);
				console.log( 'WB2.oauthData', WB2.oauthData );

				WB2.anyWhere(function(W){
					W.parseCMD('/users/show.json', function(oResult, bStatus) {
						console.log('WB parseCMD call /users/show.json arguments', arguments);

						if (bStatus){
							var emailAddr = "";
							var snsId =  WB2.oauthData.uid;
							var snsName =  oResult.name;
							var snsType = "WEIBO";
							var snsFlag = "Y";

							var registredUrl = btnWeibo.data().url;

							loginAPI({
								emailAddr : emailAddr,
								snsId : snsId,
								snsName : snsName,
								snsType : snsType,
								snsFlag : snsFlag,
								registredUrl : registredUrl,
								windowUrl : qqOptions.windowUrl
							});
						}
					},{
						//access_token : WB2.oauthData.access_token,
						uid : WB2.oauthData.uid
					},{
						method: 'get'
					});
				});
			});
		});
	}
	
	  //LGEES-295
    $('.line-container .btn-more').on('click', function() {
		var $button = $(this);
		var	$cont = $button.closest('.line-container').find('.more-detail-container');

		if ($cont.is(':visible')) {
			$button.attr('aria-expanded', false);
			$cont.stop().slideUp();
		} else {
			$button.attr('aria-expanded', true);
			$cont.stop().slideDown();
		}
    });

	var btnQQ = $(".btn-qq");
	if (btnQQ.length){

		$('script[data-callback]').removeAttr('data-callback');

		btnQQ.click(function(e){
			if ( QC.Login.check() ) {
				QC.api("get_user_info").success(function(s){
					console.log('QQ get_user_info success');
					console.log('arguments', arguments);

					QC.Login.getMe(function(openId, accessToken){
						console.log('QQ getMe Success arguments', arguments);

						var emailAddr = "";
						var snsId =  openId;
						var snsName =  s.data.nickname;
						var snsType = "QQ";
						var snsFlag = "Y";

						var registredUrl = btnQQ.data().url;

						loginAPI({
							emailAddr : emailAddr,
							snsId : snsId,
							snsName : snsName,
							snsType : snsType,
							snsFlag : snsFlag,
							registredUrl : registredUrl,
							windowUrl : qqOptions.windowUrl
						});
					});
				})
				.error(function(f){
					console.log('QQ get_user_info error', f);
				})
				.complete(function(c){
					//console.log('QQ get user info complete', c);
				});

			} else {
				QC.Login({}, function(oInfo, oOpts){
					console.log('QQ login arguments', arguments);
					
					QC.api("get_user_info").success(function(s){
						console.log('QQ get_user_info success');
						console.log('arguments', arguments);
	
						QC.Login.getMe(function(openId, accessToken){
							console.log('QQ getMe Success arguments', arguments);
	
							var emailAddr = "";
							var snsId =  openId;
							var snsName =  s.data.nickname;
							var snsType = "QQ";
							var snsFlag = "Y";
	
							var registredUrl = btnQQ.data().url;
	
							loginAPI({
								emailAddr : emailAddr,
								snsId : snsId,
								snsName : snsName,
								snsType : snsType,
								snsFlag : snsFlag,
								registredUrl : registredUrl,
								windowUrl : qqOptions.windowUrl
							});
						});
					})
					.error(function(f){
						console.log('QQ get_user_info error', f);
					})
					.complete(function(c){
						//console.log('QQ get user info complete', c);
					});
					
				});
	
				QC.Login.showPopup({
					appId : qqOptions.appid, 
					redirectURI : qqOptions.redirect_uri + '?authorizeKey=' + getUrlParams().authorizeKey
				});

			}
			
		});
	}
	
	function FBstatusChangeCallback(response) {  // Called with the results from FB.getLoginStatus().
		console.log('FBstatusChangeCallback');

		if (response.status === 'connected') {   // Logged into your webpage and Facebook.
			FB.api('/me', {fields:'email,name'}, function(response) {				
				var emailAddr = response.email || "";
				var snsId =  response.id || "";
				var snsName =  response.name || "";
				var snsType = "FACEBOOK";
				var snsFlag = "Y";

				var registredUrl = btnFacebook.data().url;

				loginAPI({
					emailAddr : emailAddr,
					snsId : snsId,
					snsName : snsName,
					snsType : snsType,
					snsFlag : snsFlag,
					registredUrl : registredUrl,
					windowUrl : fbOptions.windowUrl
				});
			});			
		} else {                                 // Not logged into your webpage or we are unable to tell.
			//
		}
	}
	
	// LGEUK-75 Start
	function twitterLoginPopup(){
		var twPopupAjaxUrl = btnTwitter.data('ajax-url');
		var twWindowPopupUrl = "";
		$.ajax({
			type: "post",
			url: twPopupAjaxUrl,
		    dataType : 'json',
		    xhrFields: {
				withCredentials: true
			},
			success: function(data) {
				console.log("twitterLoginPopup success"); // LGEIN-239
				twWindowPopupUrl=data.authorizationURL;
			},
			error: function(request,status,error) {
				console.log("twitterLoginPopup error: "+error);
				console.log("status: "+status);
			}
		}).done(function(){
			window.open(twWindowPopupUrl, "startpop", "top=0, left=0, width=800, height=500, scrollbars=no, resizable=no ,status=no ,toolbar=no");
		});
	}
	// LGEUK-75 End

	function loginAPI( res ) {
		var status;
		// Check Account SNS Registred
		$.ajax({
			type: 'post',
			url: res.registredUrl,
			async: false,
			dataType: 'json',
			data: {
				emailAddr : res.emailAddr,
				snsId : res.snsId,
				snsName: res.snsName,
				snsType : res.snsType,
				snsFlag : res.snsFlag,
				treasureType : 'login', // LGEITF-182
				tdloginType : 'social' // LGEITF-182
			},
			xhrFields: {
				withCredentials: true
			},
			success: function(resultData) {
//				console.log(resultData);
				if ( resultData.result ){
					status = "phase2";
				} else {
					status = "phase1";
				}

				//phase2, phase3
				switch(status){
					// Not Registred
					case "phase1":
						// LGEITF-182, LGEGMC-4064 Start
						if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
							var tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
							if(window.location.href.indexOf('/oauth/') >=0) {
								var actionURL = ($('#signinForm').data('action-url').length>0) ? $('#signinForm').data('action-url') : null;
								if(actionURL.indexOf('wdev50.lg.com')>=0) {
									tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
								} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
									tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
								} else if(actionURL.indexOf('www.lg.com')>=0){
									tdFailUrl="https://www.lg.com"+tdFailUrl;
								}else{
									tdFailUrl="https://"+window.location.host+tdFailUrl;
								}
							}
							$.ajax({
							    type: 'post',
							    url: tdFailUrl,
							    dataType: 'json',
							    data: {
									emailAddr : res.emailAddr,
									snsId : res.snsId,
									snsName: res.snsName,
									snsType : res.snsType,
									snsFlag : res.snsFlag,
									treasureType : 'login',
									tdloginType : 'social'
								},
								xhrFields: {
									withCredentials: true
								},
							    async: false,
							    success: function(failData) {
							    	if(resultData.error.tdMessage){
							    		failData["failMessage"]=resultData.error.tdMessage;
							    	}else{
							    		failData["failMessage"]=resultData.error.message;
									}
									if(resultData.error.tdTypeFail){
										failData["tdTypeFail"]=resultData.error.tdTypeFail;
									}
							    	treasuredataInit(failData,'FAIL');
							    },
							    error: function(request,status,error) {
							        console.log("status: "+status);
							        console.log("error: "+error);
							    }
							});
						//LGCOMITF-123-2 start
						} else if ( cookieA ) {
							var tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
							if(window.location.href.indexOf('/oauth/') >=0) {
								var actionURL = ($('#signinForm').data('action-url').length>0) ? $('#signinForm').data('action-url') : null;
								if(actionURL.indexOf('wdev50.lg.com')>=0) {
									tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
								} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
									tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
								} else if(actionURL.indexOf('www.lg.com')>=0){
									tdFailUrl="https://www.lg.com"+tdFailUrl;
								}else{
									tdFailUrl="https://"+window.location.host+tdFailUrl;
								}
							}
							$.ajax({
							    type: 'post',
							    url: tdFailUrl,
							    dataType: 'json',
							    data: {
									emailAddr : res.emailAddr,
									snsId : res.snsId,
									snsName: res.snsName,
									snsType : res.snsType,
									snsFlag : res.snsFlag,
									treasureType : 'login',
									tdloginType : 'social'
								},
								xhrFields: {
									withCredentials: true
								},
							    async: false,
							    success: function(failData) {
							    	if(resultData.error.tdMessage){
							    		failData["failMessage"]=resultData.error.tdMessage;
							    	}else{
							    		failData["failMessage"]=resultData.error.message;
									}
									if(resultData.error.tdTypeFail){
										failData["tdTypeFail"]=resultData.error.tdTypeFail;
									}
							    	nonTreasureDataInsertTable(failData);
							    },
							    error: function(request,status,error) {
							        console.log("status: "+status);
							        console.log("error: "+error);
							    }
							});
						}
						// LGEITF-182, LGEGMC-4064 End	//LGCOMITF-123-2 end
						
						openWin(res.windowUrl+"?snsEmail="+ res.emailAddr + "&snsName="+ encodeURI(res.snsName) +"&snsId=" + res.snsId + "&snsFlag=Y"+ "&snsType="+ res.snsType, "signinWin", 600, 730);
						break;
					// Registred
					case "phase2":
						resultData.snsFlag = "Y";
						resultData.snsName = res.snsName;
						resultData.snsId = res.snsId;
						resultData.snsType = res.snsType;
						/* LGEUK-75 , LGEGMC-4064 : 20221012 add */
						if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
							treasuredataInit(resultData, 'loginAPI');
						}else{
							//LGCOMITF-123-2 start
							if ( cookieA ) {
								nonTreasureDataInsertTable(resultData);
							}
							//LGCOMITF-123-2 end
							signinParentConfirm(resultData);
						}
						/*// LGEUK-75 , LGEGMC-4064 : 20221012: 20200718 add */
						
						break;
				}
			},
			error: function(request,status,error) {
				console.log("status: "+status);
				console.log("error: "+error);
				
			}
		});
		
	}

	// LGEUK-75 Start
	function twLoginAPI( res ) {
		var status;
		// Check Account SNS Registred
		$.ajax({
			type: 'post',
			url: res.registredUrl,
			async: false,
			dataType: 'json',
			data: {
				emailAddr : res.emailAddr,
				snsId : res.snsId,
				snsName: res.snsName,
				snsType : res.snsType,
				snsFlag : res.snsFlag,
				treasureType : 'login', // LGEITF-182
				tdloginType : 'social' // LGEITF-182
			},
			xhrFields: {
				withCredentials: true
			},
			success: function(resultData) {
//				console.log(resultData);
				if ( resultData.result ){
					status = "phase2";
				} else {
					status = "phase1";
				}

				//phase2, phase3
				switch(status){
					// Not Registred
					case "phase1":
						// LGEITF-182, LGEGMC-4064 Start
						if(cookieA && treasureDataFlag == 'Y'){ // LGCOMTIF-123
							var tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
							if(window.location.href.indexOf('/oauth/') >=0) {
								var actionURL = ($('#signinForm').data('action-url').length>0) ? $('#signinForm').data('action-url') : null;
								if(actionURL.indexOf('wdev50.lg.com')>=0) {
									tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
								} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
									tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
								} else if(actionURL.indexOf('www.lg.com')>=0){
									tdFailUrl="https://www.lg.com"+tdFailUrl;
								}else{
									tdFailUrl="https://"+window.location.host+tdFailUrl;
								}
							}
							$.ajax({
							    type: 'post',
							    url: tdFailUrl,
							    dataType: 'json',
							    data: {
									emailAddr : res.emailAddr,
									snsId : res.snsId,
									snsName: res.snsName,
									snsType : res.snsType,
									snsFlag : res.snsFlag,
									treasureType : 'login',
									tdloginType : 'social' 
								},
								xhrFields: {
									withCredentials: true
								},
							    async: false,
							    success: function(failData) {
							    	if(resultData.error.tdMessage){
							    		failData["failMessage"]=resultData.error.tdMessage;
							    	}else{
							    		failData["failMessage"]=resultData.error.message;
									}
									if(resultData.error.tdTypeFail){
										failData["tdTypeFail"]=resultData.error.tdTypeFail;
									}
							    	treasuredataInit(failData,'FAIL');
							    },
							    error: function(request,status,error) {
							        console.log("status: "+status);
							        console.log("error: "+error);
							    }
							});
						}
						// LGEITF-182, LGEGMC-4064 End
						
						console.log("Not Registered error");
						break;
					// Registred
					case "phase2":
						resultData.snsFlag = "Y";
						resultData.snsName = res.snsName;
						resultData.snsId = res.snsId;
						resultData.snsType = res.snsType;
						//LGEGMC-4064 start
						if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
							setTimeout(function(){
							treasuredataInit(resultData, 'twLoginAPI');
							}, 200);
						}else{
							window.opener.parent.twitterSigninParentConfirm(resultData);
							setTimeout(function(){
								 window.self.close();
							}, 200);
						}
						//LGEGMC-4064 end
						break;
				}
			},
			error: function(request,status,error) {
				console.log("status: "+status);
				console.log("error: "+error);
				
			}
		});
		
	}
	// LGEUK-75 End
	/************************************************
	POPUP
	*************************************************/
	var phase = "phase-sign-in-up"; //phase-sign-in-up, phase-email-resend, phase-check-policy
	var $signInUP = $(".phase-sign-in-up");
	var $phs_emailResend = $(".phase-email-resend");
	var $phs_checkPolicy = $(".phase-check-policy");
	var isPassDup = false;
	var dupEmailVal = getUrlParams().snsEmail || "";
	var snsName = decodeURI( getUrlParams().snsName ) || "";
	var snsType = getUrlParams().snsType || "";
	var snsId = getUrlParams().snsId;
	var $emailField = $("#sns-txtBoxEmail");
	var $emailForm = $('#emailForm');
	var $btnDupChk = $("#btnDupChk");
	var $signInForm = $("#snsSigninForm");
	var $signUpForm = $("#snsSignupForm");
	var dupChkUrl = $btnDupChk.data("checkUrl");
	var $errorBlock = $(".email-account .error-msg");
	var $information = $(".email-account .information-msg");
	var $emlRsdForm = $("#snsEmailResendForm");
	var $plcForm = $("#privacyPolicyForm");
	var u;
	var snsEmailAddr = getUrlParams().snsEmail || ""; // LGEUK-75

	//LGEUK-75 Start
	var twitterSnsPopUseFlag = $('#twitterSnsPopUseFlag').val();
	if(twitterSnsPopUseFlag=='Y'){
		if(snsName == 'undefined' || snsName == ''){snsName = $('#twitterSnsNameHidden').val()}
		if(!snsType){snsType = $('#twitterSnsTypeHidden').val()}
		if(!snsId){snsId = $('#twitterSnsIdHidden').val()}
		
		var signUpCheckResult = $('#signUpCheckResultHidden').val();
		var twitterEmailAddr = "";
		var lgEmailAddr = $('#twitterEmailAddrHidden').val();
		var twRegistredUrl ="";
		
		//mylg-profile-edit 페이지에서 트위터 팝업창을 열었을 경우
		if(!!window.opener.parent.document.querySelector('.my-profile-edit')){
			twRegistredUrl = $('#twitterResultUrlHidden').val();
			lgEmailAddr= window.opener.parent.$('[name="emailAddrHidden"]').val() || '';
			
			var $connectBtn = window.opener.parent.$('.connect[data-sns=TWITTER]');
			var token="";
			if (!!window.opener.parent.$('[name="_csrf"]').length){
				token = window.opener.parent.$('[name="_csrf"]').val();	
			} else {
				return false;
			}
			
			var userData = {
				'csrfToken' : token,
				'emailAddr' : twitterEmailAddr,
				'snsId' : snsId,
				'snsName' : snsName,
				'snsType' : snsType,
				'connect' : true,
				'lgEmailAddr' : lgEmailAddr
			};
			window.opener.parent.twSnsajaxCall(userData, $connectBtn);
			setTimeout(function(){
				 window.self.close();
			}, 200);
		}else{ //sso 페이지에서 트위터 팝업창을 열었을 경우
			twRegistredUrl = window.opener.parent.$(".btn-tw").data('url');
			
			if(signUpCheckResult== 'true'){ // 이미 회원가입 했는지 여부 체크
				twLoginAPI({
					emailAddr : twitterEmailAddr,
					snsId : snsId,
					snsName : snsName,
					snsType : snsType,
					snsFlag : 'Y',
					registredUrl : twRegistredUrl,
				});
			}
		}
	}
	//LGEUK-75 End
	
	$emailField.val(dupEmailVal);

	$btnDupChk.click(function(e){
		var emailVal = $emailField.val();
		$information.hide();
		if ( $emailForm.checkValidation() ){
			var resultData = getStatus(dupChkUrl, {
				"email" : xssfilter(emailVal),
				"snsType" : snsType,
				"snsFlag" : "Y"
			});
			console.log(resultData);
			if(resultData.result == true){ //true: has ID, false: no ID
				// has ID
				console.log("has LG Account"); 
				$signInForm.show();
				$signUpForm.hide();
				$signInForm.find("[name=password]").focus();
				$information.show().find(".exists").show();
				$information.find(".new").hide();
				$information.find(".check").hide();
				isPassDup = true;
				dupEmailVal = $emailField.val();
				$(this).attr("disabled", "disabled");
			}else if(resultData.result == false){
				// no ID
				console.log("no LG Account");
				$signInForm.hide();
				$signUpForm.show();
				if ($signUpForm.find("#birthDate").length){
					$signUpForm.find("#birthDate").focus();
				} else {
					$signUpForm.find("[name=password]").focus();
				}
				$information.show().find(".exists").hide();
				$information.find(".new").show();
				$information.find(".check").hide();
				isPassDup = false;
			}else{
				alert("ERROR");
			}
		}
	});

	$emailField.on("change, keyup", function(e){
		var emailVal = $(this).val();
		if(dupEmailVal !== emailVal){
			isPassDup = false;
			$btnDupChk.removeAttr("disabled");
		}
	});

	$emailField.on("keydown", function(e){		
		if(e.keyCode==13){
			e.preventDefault();
			$btnDupChk.trigger('click');
		}
	});

	

	function getStatus(targetUrl, sendData, dataType){
		console.log('getStatus arguments', arguments);
		console.log('dataType', dataType);
		var result = false;
		var jsonType = dataType;
		if ( jsonType == undefined ){
			jsonType = 'json';
		}
		console.log('jsonType', jsonType);
		$.ajax({
			type: 'post',
			url: targetUrl,
			async: false,
			dataType: jsonType,
			data: sendData,
			xhrFields: {
				withCredentials: true
			},
			success: function(data) {
				console.log(data);
				result = data;
			},
			error: function(request,status,error) {
				console.log("status: "+status);
				console.log("error: "+error);
				result = false;
			}
		});
		return result;
	}
		
	window.signinPopConfirm = function( resultData ){
		resultData.snsFlag = "Y";
		resultData.snsName = snsName;
		resultData.emailAddr = $emailField.val();
		resultData.snsId = snsId;
		resultData.snsType = snsType;

		console.log("signinPopConfirm");
		window.opener.signinParentConfirm( resultData );
		setTimeout(function(){
			window.self.close();
		}, 300);
	};
	

	window.signinParentConfirm = function( resultData ){
		console.log("signinParentConfirm resultData", resultData);

		var $signInForm = $('#signinForm');
		var $signUpForm = $('#signUpForm');

		if (!!$signInForm.length){
			$signInForm.trigger('snsLogin' , resultData);
		}

		if (!!$signUpForm.length){
			$signUpForm.trigger('snsSignup' , resultData);
		}
		
	};
	//LGEUK-75 Start
	window.twitterSigninParentConfirm = function( resultData ){
		console.log("signinParentConfirm resultData"); // LGEIN-239
		
		var $signInForm = $('#signinForm');
		var $signUpForm = $('#signUpForm');
		
		if (!!$signInForm.length){
			$signInForm.trigger('snsLogin' , resultData);
		}
		
		if (!!$signUpForm.length){
			$signUpForm.trigger('snsSignup' , resultData);
		}
	};
	//LGEUK-75 End

	$signInForm.find('[type=submit]').on('click', function(e){
		console.log($signInForm.attr("name")||$signInForm.attr("id"), e.type, "...");
		e.preventDefault();

		var $password = $signInForm.find('[name=password]');
		var $field = $password.parents('.field-block');
		var $errorBlock = $field.find('.error-msg');
		var $messageSpan = $errorBlock.find('.ajax-msg');

		if( isPassDup && $signInForm.checkValidation() ){
			console.log("로그인합니다");
			//before submit
			var sendData = "emailAddr="+$emailField.val()+"&"+$signInForm.serialize();
			sendData += "&snsFlag=Y";
			sendData += "&snsName=" + snsName;
			sendData += "&snsId=" + snsId;
			sendData += "&snsType=" + snsType;			
			sendData += "&snsEmailAddr=" + snsEmailAddr; //LGEUK-75		
			sendData += "&treasureType=login"; //LGEITF-182		
			sendData += "&tdloginType=social"; //LGEITF-182	
		
			console.log('signIn sendData', sendData);
			var resultData = getStatus($signInForm.attr("action"), sendData);
			
			// LGEITF-182 Start
			if(!treasureDataFlag){
				treasureDataFlag= resultData.treasureDataFlag;
			}
			// LGEITF-182 End
			if(resultData.result){
				/* LGEUK-75 , LGEGMC-4064 : 20221012 add */
				if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
					treasuredataInit(resultData, 'signInFormSubmit');
				}else{
					parent.signinPopConfirm( resultData );
				}
				/*// LGEUK-75 , LGEGMC-4064 : 20221012 add */
			}else{
				// LGEITF-182  , LGEGMC-4064 Start
				if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
					var tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
					if(window.location.href.indexOf('/oauth/') >=0) {
						var actionURL = ($signInForm.data('action-url').length>0) ? $signInForm.data('action-url') : null;
						if(actionURL.indexOf('wdev50.lg.com')>=0) {
							tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
						} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
							tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
						} else if(actionURL.indexOf('www.lg.com')>=0){
							tdFailUrl="https://www.lg.com"+tdFailUrl;
						}else{
							tdFailUrl="https://"+window.location.host+tdFailUrl;
						}
					}
					$.ajax({
					    type: 'post',
					    url: tdFailUrl,
					    dataType: 'json',
					    data: sendData,
					    xhrFields: {
							withCredentials: true
						},
					    async: false,
					    success: function(failData) {
					    	if(resultData.error.tdMessage){
					    		failData["failMessage"]=resultData.error.tdMessage;
					    	}else{
					    		failData["failMessage"]=resultData.error.message;
							}
							if(resultData.error.tdTypeFail){
								failData["tdTypeFail"]=resultData.error.tdTypeFail;
							}
					    	treasuredataInit(failData,'FAIL');
					    },
					    error: function(request,status,error) {
					        console.log("status: "+status);
					        console.log("error: "+error);
					    }
					});
				}
				// LGEITF-182 , LGEGMC-4064 End
				//alert("Check Failed");				
				$field.addClass('error');
				$errorBlock.find('span').hide();				
				$messageSpan.text(resultData.error.message);
				$messageSpan.show();
			}
			
		}else{
			console.log("이메일 중복체크 다시하세요");
			$information.find(".exists").hide();
			$information.find(".new").hide();
			$information.find(".check").show();
			$btnDupChk.focus();
		}
	});

	$signUpForm.find('[type=submit]').on("click", function(e){
		e.preventDefault();

		$signUpForm.find('.field-block').removeClass('error');	// error reset
		$signUpForm.find('.field-block .error-msg span').hide();

		var sendData = "emailAddr="+$emailField.val()+"&"+$signUpForm.serialize();
		sendData += "&snsFlag=Y";
		sendData += "&snsName=" + snsName;
		sendData += "&snsId=" + snsId;
		sendData += "&snsType=" + snsType;
		sendData += "&snsEmailAddr=" + snsEmailAddr; // LGEUK-75
		sendData += "&treasureType=signup"; //LGEITF-182		
		sendData += "&tdloginType=social"; //LGEITF-182	

		console.log('signUp sendData', sendData);
		
		if ( $signUpForm.checkValidation() ){
			var resultData = getStatus($signUpForm.attr("action"), sendData);
			// LGEITF-182 Start
			if(!treasureDataFlag){
				treasureDataFlag= resultData.treasureDataFlag;
			}
			// LGEITF-182 End
			if(resultData.result){		
				/* LGEUK-75 , LGEGMC-4064 : 20221012 add */
				if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
					treasuredataInit(resultData, 'signUpFormSubmit');
				}else{
					parent.signinPopConfirm( resultData );
				}
				/*// LGEUK-75 , LGEGMC-4064 : 20221012 add */				
			} else {
				// LGEITF-182, LGEGMC-4064  Start
				if(cookieA && treasureDataFlag == 'Y'){ // LGCOMTIF-123
					var tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
					if(window.location.href.indexOf('/oauth/') >=0) {
						var actionURL = ($signUpForm.data('action-url').length>0) ? $signUpForm.data('action-url') : null;
						if(actionURL.indexOf('wdev50.lg.com')>=0) {
							tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
						} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
							tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
						} else if(actionURL.indexOf('www.lg.com')>=0){
							tdFailUrl="https://www.lg.com"+tdFailUrl;
						}else{
							tdFailUrl="https://"+window.location.host+tdFailUrl;
						}
					}
					$.ajax({
					    type: 'post',
					    url: tdFailUrl,
					    dataType: 'json',
					    data: sendData,
					    xhrFields: {
							withCredentials: true
						},
					    async: false,
					    success: function(failData) {
							failData["failMessage"]=resultData.error.message;
							if(resultData.error.tdTypeFail){
								failData["tdTypeFail"]=resultData.error.tdTypeFail;
							}
					    	treasuredataInit(failData,'FAIL');
					    },
					    error: function(request,status,error) {
					        console.log("status: "+status);
					        console.log("error: "+error);
					    }
					});
				}
				// LGEITF-182, LGEGMC-4064  End
				if ( resultData.error.message ){
					if ( !!resultData.error.password ){
						var $passwordField = $signUpForm.find('input[name="password"]');
						var $passwordBlock = $passwordField.parents('.field-block').addClass('error');
						$passwordBlock.find('span.ajax-msg').text( resultData.error.password ).show();
						$passwordField.focus();
					} 
					if ( !!resultData.error.birthDate ) {
						var $birthDateField = $signUpForm.find('input[name="birthDate"]');
						var $birthDateBlock = $birthDateField.parents('.field-block').addClass('error');
						$birthDateBlock.find('span.ajax-msg').text( resultData.error.birthDate ).show();
						$birthDateField.focus();
					}
				}
			}
		}
		
	});
	
	/************************************************
	FACEBOOK
	*************************************************/
	//2. JavaScript용 Facebook SDK 설정
	/* LGEUK-75 : 20200728 modify */
	console.log('facebook cookieA >> '+cookieA)
	if(cookieA || treasureDataFlag != 'Y'){
		if(window.fbOptions){
			(function(d, s, id){
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) {return;}
				js = d.createElement(s); js.id = id;
				js.src = "https://connect.facebook.net/"+ fbOptions.localeCode /* ex)ko_KR */+"/sdk.js";
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'facebook-jssdk'));

			window.fbAsyncInit = function() {
				FB.init(fbOptions);
				
				FB.AppEvents.logPageView();
				FB.getLoginStatus(function(response) {
					//console.log('getLoginStatus');
					//FBstatusChangeCallback(response);
				});
			};
		}
	}
	/*// LGEUK-75 : 20200728 modify */

	//JavaScript용 Weibo SDK 설정
	if(window.wbOptions){
		/*
		(function(d, s, id){
			var js, fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) {return;}
			js = d.createElement(s); js.id = id;
			//js.src = "http://tjs.sjs.sinajs.cn/t3/platform/js/api/wb.js";		
			js.src = "https://tjs.sjs.sinajs.cn/open/api/js/wb.js?appkey="+ wbOptions.appid + "&debug=true";
			fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'weibo-jssdk'));
		*/
		

		/*
		WB.core.load(['connect', 'client'], function() {
			var cfg = { 
				key : wbOptions.appid, 
				xdpath : wbOptions.redirect_uri
			};
			WB.connect.init (cfg);
			WB.client.init (cfg);
		});
		*/
	}
	//JavaScript용 QQ SDK 설정
	if(window.qqOptions){	
		/*
		(function(d, s, id){
			var js, fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) {return;}
			js = d.createElement(s); js.id = id;
			js.src = "https://connect.qq.com/qc_jssdk.js";
			//js.src = "https://qzonestyle.gtimg.cn/qzone/openapi/qc_loader.js";
			js.setAttribute('data-appid', qqOptions.appid);
			js.setAttribute('data-redirecturi', qqOptions.redirect_uri);
			js.setAttribute('data-callback', 'true');		
			fjs.parentNode.insertBefore(js, fjs);		
		}(document, 'script', 'qq-jssdk'));
		*/
		
	}
	
	// LGEIN-239 Start
	/************************************************
	GOOGLE
	*************************************************/
	//JavaScript용  Google SDK 설정
	if(window.ggOptions){
		(function(d, s, id){
			var js, fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) {return;}
			js = d.createElement(s); js.id = id;
			js.src = "https://apis.google.com/js/api:client.js?onload=ggStartApp";
			fjs.parentNode.insertBefore(js, fjs);		
		}(document, 'script', 'google-jssdk'));
	}
	// LGEIN-239 End

	// LGEUK-75 Start 
	// Treasure Data Tracking
	var td_client_id_cookie = '';
	var td_global_id = '';
	var td_ssc_id = '';
	function getCookieTd(name) {
		if ($.cookie(name)) {
			return decodeURIComponent($.cookie(name));
		} else {
			$.cookie(name);
		}
	}
	function treasuredataInit(resultData, type) {
	  	var tdLoginStatus = new Treasure({
		    host: 'eu01.in.treasuredata.com',
		    writeKey: resultData.apikey,
		    database: resultData.database,
		    sscDomain: 'lg.com',
		    sscServer: 'ssc.lg.com',
		    useServerSideCookie: true
		});

	  	tdLoginStatus.setSignedMode();

		// Enable cross-domain tracking
		tdLoginStatus.set('$global', 'td_global_id', 'td_global_id');
	    
	    var successCallback_ssc = function (serverSideId) {
	    	console.log('successCallback_ssc');
	    	td_ssc_id = serverSideId;
	    	tdLoginStatus.fetchGlobalID(successCallback, errorCallback);
    	};
    	var errorCallback_ssc = function (error) {
		  console.log('errorCallback_ssc :: '+error);
		}
    	tdLoginStatus.fetchServerCookie(successCallback_ssc, errorCallback_ssc);

	    // Receive td_global_id
	    var successCallback = function(td_global_id_data) {
	    	console.log('successCallback');
			td_global_id = td_global_id_data;
			td_client_id_cookie = getCookieTd('_td');
			
			treasuredataAjax(resultData);
		
			if(type == 'twLoginAPI'){
				window.opener.parent.twitterSigninParentConfirm(resultData);
				setTimeout(function(){
					window.self.close(); 
				}, 200);
			}else if(type == 'loginAPI'){
				signinParentConfirm(resultData);
			}else if(type == 'signInFormSubmit' || type == 'signUpFormSubmit'){
				parent.signinPopConfirm( resultData );		
			// LGEITF-182 Start
			}else if(type == 'FAIL'){
				console.log('Treasure data Login Fail');
			}		
			// LGEITF-182 End
	    };
	    var errorCallback = function(err) {
	    	console.log('errorCallback');
			td_client_id_cookie = getCookieTd('_td');
			treasuredataAjax(resultData);
			
			if(type == 'twLoginAPI'){
				window.opener.parent.twitterSigninParentConfirm(resultData);
				setTimeout(function(){
					 window.self.close();
				}, 300);
			}else if(type == 'loginAPI'){
				signinParentConfirm(resultData);
			}else if(type == 'signInFormSubmit' || type == 'signUpFormSubmit'){
				parent.signinPopConfirm( resultData );
			// LGEITF-182 Start
			}else if(type == 'FAIL'){
				console.log('Treasure data Login Fail');
			}		
			// LGEITF-182 End
	    };

			
	}

	function treasuredataAjax(resultData){
		var treasuredataUrl = resultData.host; // LGEITF-421
			treasuredataUrl += resultData.database+ '/';
			treasuredataUrl += resultData.table+ '?';
			treasuredataUrl += 'td_write_key='+resultData.apikey;
			treasuredataUrl += '&td_client_id='+td_client_id_cookie;
			treasuredataUrl += '&td_global_id='+td_global_id;
			treasuredataUrl += '&td_ssc_id='+td_ssc_id;
		
			// LGEITF-182 Start
			if(resultData.timeSuccess)
				treasuredataUrl += '&time_success='+resultData.timeSuccess;
			if(resultData.typeSuccess)
				treasuredataUrl += '&type_success='+resultData.typeSuccess;
			if(resultData.typeLogin)
				treasuredataUrl += '&type_login='+resultData.typeLogin;
			if(resultData.typeSocial)
				treasuredataUrl += '&type_social='+resultData.typeSocial;
			if(resultData.lgeId)
				treasuredataUrl += '&lge_id='+resultData.lgeId;
			if(resultData.tdEmail)
				treasuredataUrl += '&email='+resultData.tdEmail;
			if(resultData.tdPhone)
				treasuredataUrl += '&phone='+resultData.tdPhone;
			if(resultData.nameFirst)
				treasuredataUrl += '&name_first='+resultData.nameFirst;
			if(resultData.nameLast)
				treasuredataUrl += '&name_last='+resultData.nameLast;
			if(resultData.sodialIdTwitter)
				treasuredataUrl += '&social_id_twitter='+resultData.sodialIdTwitter;
			if(resultData.screenNameTwitter)
				treasuredataUrl += '&screen_name_twitter='+resultData.screenNameTwitter;
			if(resultData.socialIdFb)
				treasuredataUrl += '&social_id_fb='+resultData.socialIdFb;
			if(resultData.nameFullFb)
				treasuredataUrl += '&name_full_fb='+resultData.nameFullFb;
			if(resultData.typeLoginResult)
				treasuredataUrl += '&type_login_result='+resultData.typeLoginResult;
			if(resultData.failMessage)
				treasuredataUrl += '&type_fail_reason='+resultData.failMessage;
			if(resultData.localeCode)
				treasuredataUrl += '&locale_code='+resultData.localeCode;
			if(resultData.corporationCode)
				treasuredataUrl += '&corporation_code='+resultData.corporationCode;
			if(resultData.cdpNameCode)
				treasuredataUrl += '&cdp_name_code='+resultData.cdpNameCode;
			if(resultData.cdpName)
				treasuredataUrl += '&cdp_name='+resultData.cdpName;
			if(resultData.tdTypeFail)
				treasuredataUrl += '&type_fail='+resultData.tdTypeFail;
			if(resultData.noPhoneNameReason)
				treasuredataUrl += '&no_phone_name_reason='+resultData.noPhoneNameReason;
			if(resultData.socialIdEtc && resultData.typeSocial)
				treasuredataUrl += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + resultData.socialIdEtc;
			// LGEITF-182 End
			
		if(cookieA && treasureDataFlag == 'Y'){
			$.ajax({
			    url : treasuredataUrl,
			    type : 'POST',
			    dataType : 'jsonp',
				jsonpCallback: "callback",
				async: false,
			    crossDomain: true,
			    beforeSend: function (xhr) {
					xhr.setRequestHeader("Content-type","application/json");
					xhr.setRequestHeader("X-TD-Write-Key",resultData.apikey);
				},
			    success : function(data){
	//				console.log(data);
			    	console.log('treasuredata post success'); // LGEIN-239
				}
			});
		}
		
		//LGEGMC-4064 start
		var treasuredataInsertParam = "";
		if(resultData.apikey)
			treasuredataInsertParam += 'td_write_key='+encodeURIComponent(resultData.apikey);
		if(td_client_id_cookie)
			treasuredataInsertParam += '&td_client_id='+encodeURIComponent(td_client_id_cookie);
		if(td_global_id)
			treasuredataInsertParam += '&td_global_id='+encodeURIComponent(td_global_id);
		if(td_ssc_id)
			treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent(td_ssc_id);
		if(resultData.timeSuccess)
			treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
		if(resultData.typeSuccess)
			treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
		if(resultData.typeLogin)
			treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
		if(resultData.typeSocial)
			treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
		if(resultData.lgeId)
			treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
		if(resultData.tdEmail)
			treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
		if(resultData.tdPhone)
			treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
		if(resultData.nameFirst)
			treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
		if(resultData.nameLast)
			treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
		if(resultData.sodialIdTwitter)
			treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
		if(resultData.screenNameTwitter)
			treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
		if(resultData.socialIdFb)
			treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
		if(resultData.nameFullFb)
			treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
		if(resultData.typeLoginResult)
			treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
		if(resultData.failMessage)
			treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
		if(resultData.localeCode)
			treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
		if(resultData.corporationCode)
			treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
		if(resultData.cdpNameCode)
			treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
		if(resultData.cdpName)
			treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
		if(resultData.tdTypeFail)
			treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
		if(resultData.noPhoneNameReason)
			treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
		if(resultData.socialIdEtc && resultData.typeSocial)
			treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
		if(resultData.database)
			treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
		if(resultData.table)
			treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
		treasureDataInsertTable(treasuredataInsertParam);
		//LGEGMC-4064 end
	}
	
	//LGCOMITF-123-2 start
	function nonTreasureDataInsertTable(resultData){
		//LGEGMC-4064 start
		var treasuredataInsertParam = "";
		
		//Treasure Data 미사용국가들로 인해 해당데이터는 공백으로 넘겨짐. EDL 에서도 로그인 이력이 필요할뿐 Td 관련된 데이터는 필요 없음.
		treasuredataInsertParam += 'td_write_key='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_client_id='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_global_id='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent('N/A');
		
		if(resultData.timeSuccess)
			treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
		if(resultData.typeSuccess)
			treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
		if(resultData.typeLogin)
			treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
		if(resultData.typeSocial)
			treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
		if(resultData.lgeId)
			treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
		if(resultData.tdEmail)
			treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
		if(resultData.tdPhone)
			treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
		if(resultData.nameFirst)
			treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
		if(resultData.nameLast)
			treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
		if(resultData.sodialIdTwitter)
			treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
		if(resultData.screenNameTwitter)
			treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
		if(resultData.socialIdFb)
			treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
		if(resultData.nameFullFb)
			treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
		if(resultData.typeLoginResult)
			treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
		if(resultData.failMessage)
			treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
		if(resultData.localeCode)
			treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
		if(resultData.corporationCode)
			treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
		if(resultData.cdpNameCode)
			treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
		if(resultData.cdpName)
			treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
		if(resultData.tdTypeFail)
			treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
		if(resultData.noPhoneNameReason)
			treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
		if(resultData.socialIdEtc && resultData.typeSocial)
			treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
		if(resultData.database)
			treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
		if(resultData.table)
			treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
		treasureDataInsertTable(treasuredataInsertParam);
		//LGEGMC-4064 end
	}
	//LGCOMITF-123-2 end
	
	function nvl(str, defaultStr){
		var check = str+"";
		var result = "";
		check = check.trim()
		if(check=="" || check==null || check == "null" || check=="undefined"){
			result = defaultStr;
		}else{
			result = check;
		}
		return result ;
	}
	// LGEUK-75 End
	
});